document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 990) return;

  const details = document.querySelector('#Details-HeaderMenu-3');

  if (!details) return;

  details.addEventListener('mouseenter', () => {
    details.setAttribute('open', '');
    details.querySelector('summary').setAttribute('aria-expanded', 'true');
  });

  details.addEventListener('mouseleave', () => {
    details.removeAttribute('open');
    details.querySelector('summary').setAttribute('aria-expanded', 'false');
  });
});
